import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Not Found | SagesAcademy Student Care</title>
      </Helmet>
      <div className="main-page-wrapper p0">
        <div className="error-page d-lg-flex align-items-center">
          <div className="img-holder order-lg-last">
            <img
              src="images/media/404.svg"
              alt="media"
              className="w-100 illustration"
            />
            <img
              src="images/media/404-q.svg"
              alt="media"
              className="shapes qus"
            />
          </div>
          <div className="text-wrapper order-lg-first">
            <div className="logo">
              <Link to="/">
                <img src="images/logo/sagesacademy-logo-white.svg" alt="logo" />
              </Link>
            </div>
            <h1 className="font-slab">
              Oops, <br />
              Looks like we <br />
              sent you the <br />
              wrong way.
            </h1>
            <p className="font-rubik">
              Let us guide you back!
            </p>

            <Link
              to="/"
              className="back-home font-rubik d-flex align-items-center justify-content-center"
            >
              <span>Back to Home</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;